/// <amd-module name="Mention/Autocomplete/Constants" />
export module MentionCssClasses {
    const HIGHLIGHT = "mention-autocomplete-highlight";
}
